export default __webpack_public_path__ + "static/media/NeurialGrotesk.822d64b8.woff";